// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { agentScopesGuard, agentServiceGrantStatusGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    agentId: z.string().min(1).max(21),
    service: z.string().min(1).max(128),
    audience: z.string().min(1).max(256),
    scopes: agentScopesGuard.optional(),
    status: agentServiceGrantStatusGuard.optional(),
    approvedBy: z.string().max(128).nullable().optional(),
    approvedAt: z.number().nullable().optional(),
    revokedAt: z.number().nullable().optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    agentId: z.string().min(1).max(21),
    service: z.string().min(1).max(128),
    audience: z.string().min(1).max(256),
    scopes: agentScopesGuard,
    status: agentServiceGrantStatusGuard,
    approvedBy: z.string().max(128).nullable(),
    approvedAt: z.number().nullable(),
    revokedAt: z.number().nullable(),
    createdAt: z.number(),
});
export const AgentServiceGrants = Object.freeze({
    table: 'agent_service_grants',
    tableSingular: 'agent_service_grant',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        agentId: 'agent_id',
        service: 'service',
        audience: 'audience',
        scopes: 'scopes',
        status: 'status',
        approvedBy: 'approved_by',
        approvedAt: 'approved_at',
        revokedAt: 'revoked_at',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'agentId',
        'service',
        'audience',
        'scopes',
        'status',
        'approvedBy',
        'approvedAt',
        'revokedAt',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
